import script from "./class.vue?vue&type=script&setup=true&lang=js"
export * from "./class.vue?vue&type=script&setup=true&lang=js"

import "./class.vue?vue&type=style&index=0&id=47c5856f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c5856f"]])

export default __exports__